import { ActionType } from "../../classes/calendar-actions";
import { ICalendarAppText } from '../../custom/classes/calendar-text';


export function requestText() {
    return {
        type: ActionType.RequestText
    }
}

export function receiveText(text: ICalendarAppText) {
    return {
        type: ActionType.ReceiveText,
        value: text
    }
}

export function errorApiText(error: any) {
    return {
        type: ActionType.ErrorApiText,
        value: error
    }
}